import { useCanAccess } from "ra-core";

/**
 * Import and export (CSV, JSON, vCard) are owner-only for now. "export" is a
 * pseudo-resource of the authProvider; Task 5c maps it to the personal right
 * «выгрузка» (sales.can_export) the owner gives each employee.
 */
export const useCanExport = () => {
  const { canAccess, isPending } = useCanAccess({
    resource: "export",
    action: "export",
  });
  return { canExport: canAccess === true, isPending };
};
